import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-ea-navy border-t border-ea-dark-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-4 mb-5 cursor-pointer">
              <div className="w-20 h-20 flex items-center justify-center shrink-0">
                <img
                  src="https://static.readdy.ai/image/bcf9f2411fadd279f7d1fd38d7e2d7e8/6cfd408f22ccc1f303d260d7c847c128.png"
                  alt="Everything Automation"
                  className="w-20 h-20 object-contain"
                />
              </div>
              <span className="text-white font-bold text-xl whitespace-nowrap leading-snug">
                Everything <br /><span className="text-ea-blue">Automation</span>
              </span>
            </Link>
            <p className="text-ea-gray text-sm leading-relaxed mb-6">
              AI-powered systems that help businesses scale smarter, book more, and work less.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-ea-blue hover:bg-ea-blue-light text-white text-sm font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Get Started <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Quick Links</h3>
            <ul className="space-y-2.5">
              {[
                { label: 'Home', path: '/' },
                { label: 'About Us', path: '/about' },
                { label: 'Industries', path: '/industries' },
                { label: 'Pricing', path: '/pricing' },
                { label: 'Contact', path: '/contact' },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-ea-gray hover:text-ea-blue text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Our Services</h3>
            <ul className="space-y-2.5">
              {[
                { label: 'AI Chatbots', path: '/pricing' },
                { label: 'Booking Automation', path: '/pricing' },
                { label: 'CRM Integration', path: '/pricing' },
                { label: 'Lead Management', path: '/pricing' },
                { label: 'Email Automation', path: '/pricing' },
                { label: 'WhatsApp Automation', path: '/pricing' },
              ].map((service) => (
                <li key={service.label}>
                  <Link
                    to={service.path}
                    className="text-ea-gray hover:text-ea-blue text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Get In Touch</h3>
            <div className="space-y-3">
              <a
                href="mailto:sales@everythingautomation.co"
                className="flex items-center gap-3 text-ea-gray hover:text-ea-blue text-sm transition-colors duration-200 cursor-pointer"
                rel="nofollow"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-ea-blue"></i>
                </div>
                sales@everythingautomation.co
              </a>
              <a
                href="https://wa.me/447450946360"
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-center gap-3 text-ea-gray hover:text-ea-blue text-sm transition-colors duration-200 cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-ea-blue"></i>
                </div>
                +44 7450 946360
              </a>
              <div className="flex items-start gap-3 text-ea-gray text-sm">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-time-line text-ea-blue"></i>
                </div>
                Response within 2 hours
              </div>
              <div className="flex items-start gap-3 text-ea-gray text-sm">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-calendar-check-line text-ea-blue"></i>
                </div>
                Mon–Fri, 9am–7pm UK time
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-ea-dark-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-ea-gray text-xs">
            &copy; {currentYear} Everything Automation. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy-policy" rel="nofollow" className="text-ea-gray hover:text-ea-blue text-xs transition-colors duration-200 cursor-pointer">
              Privacy Policy
            </Link>
            <span className="text-ea-dark-border">|</span>
            <Link to="/terms-of-service" rel="nofollow" className="text-ea-gray hover:text-ea-blue text-xs transition-colors duration-200 cursor-pointer">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
